// "use client"
import React, { useState, useEffect, useRef, useMemo } from "react";
import { MDBDataTable } from "mdbreact"
import { FiCopy, FiMoreVertical } from "react-icons/fi"
import { FaPlus, FaTicketAlt, FaPercentage, FaUsers, FaClock, FaSearch } from "react-icons/fa"
import { Link } from "react-router-dom"
import CreateCouponDrawer from "./CreateCouponDrawer"
import ConfirmationModal from "../../ReuseUI/ConfirmModel"
import SmallSpinner from "../../ReuseUI/Spinner"
import "./Coupon.css"
import { GetAllCouponsData, UpdateCouponsData } from "../../../api/Webservices"
import { showToast, ToastMessage } from "../../Shared/ToastMessage"
import { useUser } from "../../AdminUsers/UserContext"

const Coupons = () => {
  const { checkPermission } = useUser()
  const [activeTab, setActiveTab] = useState("all")
  const [searchTerm, setSearchTerm] = useState("")
  const [showCreateDrawer, setShowCreateDrawer] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [couponToEdit, setCouponToEdit] = useState(null)
  const [coupons, setCoupons] = useState([])
  const [apiCoupons, setApiCoupons] = useState([])
  const [loading, setLoading] = useState(false)
  const [apiError, setApiError] = useState(null)

  // State for notification
  const [notification, setNotification] = useState({
    show: false,
    type: "", // "success", "error", or "info"
    message: "",
  })

  // State for delete confirmation modal
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  const [couponToDelete, setCouponToDelete] = useState(null)

  // Refs for handling outside clicks
  const actionMenuRef = useRef(null)

  const [tabCounts, setTabCounts] = useState({
    all: 0,
    active: 0,
    paused: 0,
    expired: 0,
    drafts: 0,
    deleted: 0,
  })

  // JSX Methods for rendering different sections
  const renderHeader = () => (
    // <div style={{ marginBottom: "24px" }}>
    //   <div
    //     style={{
    //       margin: "0 auto",
    //       padding: "0 2rem",
    //       backgroundColor: "#ffffff",
    //       boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    //       borderRadius: "12px",
    //     }}
    //   >
    //     <div
    //       style={{
    //         display: "flex",
    //         justifyContent: "space-between",
    //         alignItems: "center",
    //         padding: "1.5rem 0",
    //       }}
    //     >
    //       <div
    //         style={{
    //           display: "flex",
    //           flexDirection: "column",
    //           gap: "0.75rem",
    //         }}
    //       >
    //         <div
    //           style={{
    //             display: "flex",
    //             alignItems: "center",
    //             gap: "1rem",
    //           }}
    //         >
    //           <h1
    //             style={{
    //               fontSize: "28px",
    //               fontWeight: "700",
    //               color: "#1f2937",
    //               margin: 0,
    //               lineHeight: "1.2",
    //             }}
    //           >
    //             Coupons
    //           </h1>
    //         </div>
    //         <nav
    //           style={{
    //             display: "flex",
    //             alignItems: "center",
    //             gap: "0.5rem",
    //             fontSize: "0.875rem",
    //           }}
    //         >
    //           <Link
    //             to="/events/admin/"
    //             style={{
    //               color: "#184778",
    //               textDecoration: "none",
    //               fontWeight: "500",
    //               transition: "color 0.2s ease",
    //             }}
    //           >
    //             AMASI
    //           </Link>
    //           <span
    //             style={{
    //               color: "#9ca3af",
    //               fontSize: "1rem",
    //             }}
    //           >
    //             /
    //           </span>
    //           <span
    //             style={{
    //               color: "#6b7280",
    //             }}
    //           >
    //             Coupons
    //           </span>
    //         </nav>
    //       </div>
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //         }}
    //       >
    //         <button
    //           style={{
    //             display: "flex",
    //             alignItems: "center",
    //             gap: "0.5rem",
    //             padding: "0.75rem 1.5rem",
    //             background: "linear-gradient(135deg, #184778 0%, #1e5a8a 100%)",
    //             color: "#ffffff",
    //             border: "none",
    //             borderRadius: "8px",
    //             fontSize: "0.875rem",
    //             fontWeight: "600",
    //             cursor: "pointer",
    //             transition: "all 0.2s ease",
    //             boxShadow: "0 2px 4px rgba(24, 71, 120, 0.2)",
    //           }}
    //           onClick={handleCreateCoupon}
    //           onMouseEnter={(e) => {
    //             e.currentTarget.style.transform = "translateY(-1px)"
    //             e.currentTarget.style.boxShadow = "0 4px 8px rgba(24, 71, 120, 0.3)"
    //           }}
    //           onMouseLeave={(e) => {
    //             e.currentTarget.style.transform = "translateY(0)"
    //             e.currentTarget.style.boxShadow = "0 2px 4px rgba(24, 71, 120, 0.2)"
    //           }}
    //         >
    //           <FaPlus />
    //           Create Coupon
    //         </button>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div style={{ marginBottom: "22px" }}>
      <div className="brood_comes_div">
        <div className="row align-items-center">
          <div className="col-md-6 brood_comes_heading">
            <h2>
              <div className="brood_comes_part">
                <FaTicketAlt />
              </div>
              Coupon
            </h2>

          </div>
          <div className="col-md-6 text-end">
            <button
              className="btn btn-outline-primary "
              onClick={handleCreateCoupon}
            >
              <FaPlus />
              Create Coupon
            </button>
          </div>
        </div>


      </div>
    </div>
  )

   const renderStatsCards = () => (
    <></>
  //   <div style={{ marginBottom: "24px" }}>
  //     <div
  //       style={{
  //         display: "grid",
  //         gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
  //         gap: "1rem",
  //       }}
  //     >
  //       <div
  //         style={{
  //           backgroundColor: "#ffffff",
  //           padding: "20px",
  //           borderRadius: "12px",
  //           boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  //           display: "flex",
  //           alignItems: "center",
  //           gap: "1rem",
  //           transition: "transform 0.2s ease, box-shadow 0.2s ease",
  //         }}
  //       >
  //         <div
  //           style={{
  //             width: "48px",
  //             height: "48px",
  //             borderRadius: "12px",
  //             backgroundColor: "#e0f2fe",
  //             color: "#184778",
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "center",
  //             fontSize: "1.25rem",
  //           }}
  //         >
  //           <FaTicketAlt />
  //         </div>
  //         <div style={{ flex: 1 }}>
  //           <div
  //             style={{
  //               fontSize: "1.875rem",
  //               fontWeight: "700",
  //               color: "#1f2937",
  //               lineHeight: "1",
  //             }}
  //           >
  //             {tabCounts.all}
  //           </div>
  //           <div
  //             style={{
  //               fontSize: "0.875rem",
  //               color: "#6b7280",
  //               marginTop: "0.25rem",
  //             }}
  //           >
  //             Total Coupons
  //           </div>
  //         </div>
  //       </div>

  //       <div
  //         style={{
  //           backgroundColor: "#ffffff",
  //           padding: "20px",
  //           borderRadius: "12px",
  //           boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  //           display: "flex",
  //           alignItems: "center",
  //           gap: "1rem",
  //           transition: "transform 0.2s ease, box-shadow 0.2s ease",
  //         }}
  //       >
  //         <div
  //           style={{
  //             width: "48px",
  //             height: "48px",
  //             borderRadius: "12px",
  //             backgroundColor: "#dcfce7",
  //             color: "#166534",
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "center",
  //             fontSize: "1.25rem",
  //           }}
  //         >
  //           <FaPercentage />
  //         </div>
  //         <div style={{ flex: 1 }}>
  //           <div
  //             style={{
  //               fontSize: "1.875rem",
  //               fontWeight: "700",
  //               color: "#1f2937",
  //               lineHeight: "1",
  //             }}
  //           >
  //             {tabCounts.active}
  //           </div>
  //           <div
  //             style={{
  //               fontSize: "0.875rem",
  //               color: "#6b7280",
  //               marginTop: "0.25rem",
  //             }}
  //           >
  //             ActiveCoupons
  //           </div>
  //         </div>
  //       </div>

  //       <div
  //         style={{
  //           backgroundColor: "#ffffff",
  //           padding: "20px",
  //           borderRadius: "12px",
  //           boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  //           display: "flex",
  //           alignItems: "center",
  //           gap: "1rem",
  //           transition: "transform 0.2s ease, box-shadow 0.2s ease",
  //         }}
  //       >
  //         <div
  //           style={{
  //             width: "48px",
  //             height: "48px",
  //             borderRadius: "12px",
  //             backgroundColor: "#fef3c7",
  //             color: "#92400e",
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "center",
  //             fontSize: "1.25rem",
  //           }}
  //         >
  //           <FaUsers />
  //         </div>
  //         <div style={{ flex: 1 }}>
  //           <div
  //             style={{
  //               fontSize: "1.875rem",
  //               fontWeight: "700",
  //               color: "#1f2937",
  //               lineHeight: "1",
  //             }}
  //           >
  //             {tabCounts.paused}
  //           </div>
  //           <div
  //             style={{
  //               fontSize: "0.875rem",
  //               color: "#6b7280",
  //               marginTop: "0.25rem",
  //             }}
  //           >
  //             PausedCoupons
  //           </div>
  //         </div>
  //       </div>

  //       <div
  //         style={{
  //           backgroundColor: "#ffffff",
  //           padding: "20px",
  //           borderRadius: "12px",
  //           boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  //           display: "flex",
  //           alignItems: "center",
  //           gap: "1rem",
  //           transition: "transform 0.2s ease, box-shadow 0.2s ease",
  //         }}
  //       >
  //         <div
  //           style={{
  //             width: "48px",
  //             height: "48px",
  //             borderRadius: "12px",
  //             backgroundColor: "#fee2e2",
  //             color: "#991b1b",
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "center",
  //             fontSize: "1.25rem",
  //           }}
  //         >
  //           <FaClock />
  //         </div>
  //         <div style={{ flex: 1 }}>
  //           <div
  //             style={{
  //               fontSize: "1.875rem",
  //               fontWeight: "700",
  //               color: "#1f2937",
  //               lineHeight: "1",
  //             }}
  //           >
  //             {tabCounts.expired}
  //           </div>
  //           <div
  //             style={{
  //               fontSize: "0.875rem",
  //               color: "#6b7280",
  //               marginTop: "0.25rem",
  //             }}
  //           >
  //             ExpiredCoupons
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
    )

  const renderFiltersAndTabs = () => (
    <div style={{ marginBottom: "24px" }}>
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
          overflow: "hidden",
        }}
      > 
        <div style={{ padding: "15px 24px",    display: "flex",    flexWrap: "wrap",    gap: "8px",    alignItems: "center",   justifyContent: "space-between", }}>
          <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
            {[
              { key: "all", label: `All (${tabCounts.all})` },
              { key: "active", label: `Active (${tabCounts.active})` },
              { key: "paused", label: `Paused (${tabCounts.paused})` },
              { key: "expired", label: `Expired (${tabCounts.expired})` },
              { key: "draft", label: `Drafts (${tabCounts.drafts})` },
              { key: "deleted", label: `Deleted (${tabCounts.deleted})` },
            ].map((tab) => (
              <div
                key={tab.key}
                style={{
                  padding: "12px 20px",
                  border: "none",
                  borderRadius: "8px",
                  color: activeTab === tab.key ? "#ffffff" : "#6b7280",
                  fontSize: "14px",
                  fontWeight: activeTab === tab.key ? "600" : "500",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  background:
                    activeTab === tab.key ? "linear-gradient(135deg, #184778 0%, #1e5a8a 100%)" : "transparent",
                  boxShadow: activeTab === tab.key ? "0 2px 8px rgba(24, 71, 120, 0.2)" : "none",
                  transform: activeTab === tab.key ? "translateY(-1px)" : "translateY(0)",
                  userSelect: "none",
                  whiteSpace: "nowrap",
                }}
                onClick={() => handleTabSelect(tab.key)}
                onMouseEnter={(e) => {
                  if (activeTab !== tab.key) {
                    e.currentTarget.style.backgroundColor = "#e9e9e9ff"
                    e.currentTarget.style.color = "#184778"
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeTab !== tab.key) {
                    e.currentTarget.style.backgroundColor = "transparent"
                    e.currentTarget.style.color = "#6b7280"
                  }
                }}
              >
                {tab.label}
              </div>
            ))}
          </div>
          <div style={{   }}>
            <div style={{ position: "relative", maxWidth: "400px" }}>
              <FaSearch
                style={{
                  position: "absolute",
                  left: "16px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#6b7280",
                  fontSize: "16px",
                }}
              />
              <input
                type="text"
                placeholder="Search coupons..."
                value={searchTerm}
                onChange={handleSearch}
                style={{
                  width: "100%",
                  padding: "12px 16px 12px 44px",
                  border: "2px solid #e5e7eb",
                  borderRadius: "8px",
                  fontSize: "14px",
                  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                  outline: "none",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#184778"
                  e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e5e7eb"
                  e.target.style.boxShadow = "none"
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )

  const renderDataTable = () => (
    <div style={{ marginBottom: "24px" }}>
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
          overflow: "hidden",
        }}
      >
        {apiError && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.75rem",
              padding: "1rem 1.5rem",
              backgroundColor: "#fef2f2",
              borderBottom: "1px solid #fecaca",
              color: "#991b1b",
              fontSize: "0.875rem",
            }}
          >
            <i className="fa fa-exclamation-triangle" style={{ fontSize: "1rem" }}></i>
            {apiError}
          </div>
        )}

        <div style={{ padding: "1.5rem" }}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <MDBDataTable
              noBottomColumns
              className="table table-hover js-basic-example dataTable table-custom spacing5"
              entriesOptions={[5, 10, 20, 25]}
              entries={10}
              paging
              pagesAmount={5}
              data={tableData}
              sortRows={["coupon_code"]}
              preserveScroll={true}
              preserveState={true}
              searching={false}
            />
          )}
        </div>

        <div
          style={{
            padding: "1rem 1.5rem",
            borderTop: "1px solid #e5e7eb",
            backgroundColor: "#f9fafb",
            color: "#6b7280",
            fontSize: "0.875rem",
          }}
        >
          {loading
            ? "Loading..."
            : `Showing 1 to ${tableData.rows.length} records of ${tabCounts[activeTab] || tabCounts.all}`}
        </div>
      </div>
    </div>
  )

  // Function to load coupons data
  const loadCoupons = () => {
    setLoading(true)
    GetAllCouponsData(activeTab === "all" ? "all" : activeTab)
      .then((res) => {
        if (res) {
          console.log("Coupons data:", res)
          setApiCoupons(res)
          // Set the counts for each tab
          const newTabCounts = {
            all: res.length,
            active: res.filter((c) => c.coupon_status === "active").length,
            paused: res.filter((c) => c.coupon_status === "paused").length,
            expired: res.filter((c) => c.coupon_status === "expired").length,
            drafts: res.filter((c) => c.coupon_status === "draft").length,
            deleted: res.filter((c) => c.coupon_status === "deleted").length,
          }
          setTabCounts(newTabCounts)
          // Transform API data to match the coupons structure
          const formattedCoupons = res.map((coupon) => ({
            id: coupon.id,
            coupon_code: coupon.coupon_code,
            discount:
              coupon.discount_type === "percentage"
                ? `${coupon.discount}% OFF`
                : `${coupon.currency || "$"}${coupon.discount} OFF`,
            usage: `${coupon.usage_count || 0} / ${coupon.usage_limit_enabled === "yes"
              ? coupon.total_usage_limit === null || coupon.total_usage_limit === undefined
                ? "∞"
                : coupon.total_usage_limit
              : "∞"
              }`,
            applyTo:
              coupon.apply_discount_on === "net_amount"
                ? "Net Amount"
                : coupon.apply_to_all_tickets === "yes"
                  ? "All tickets"
                  : `${coupon.ticket_ids?.length || 0} tickets`,
            expiry: coupon.expiry_date
              ? `${new Date(coupon.expiry_date).toLocaleDateString("en-US", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })} ${coupon.expiry_time || ""}`
              : "No expiry",
            status: coupon.coupon_status || "draft",
            _originalData: coupon,
          }))
          console.log("Formatted coupons:", formattedCoupons)
          setCoupons(formattedCoupons)
        }
        setLoading(false)
        setApiError(null)
      })
      .catch((err) => {
        console.error("Error loading coupons:", err)
        setLoading(false)
        setApiError("Failed to load coupons. Please try again.")
      })
  }

  useEffect(() => {
    loadCoupons()
  }, [activeTab])

  // Add event listener for clicks outside the action menu
  useEffect(() => {
    function handleClickOutside(event) {
      if (actionMenuRef.current && !actionMenuRef.current.contains(event.target)) {
        // Close any open action menus
        setCoupons((prevCoupons) =>
          prevCoupons.map((coupon) => ({
            ...coupon,
            showMenu: false,
          })),
        )
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  // Auto-hide notification after 5 seconds
  useEffect(() => {
    if (notification.show) {
      const timer = setTimeout(() => {
        closeNotification()
      }, 5000)
      return () => clearTimeout(timer)
    }
  }, [notification.show])

  const closeNotification = () => {
    setNotification({ ...notification, show: false })
  }

  const handleTabSelect = (tab) => {
    console.log("Tab selected:", tab)
    setActiveTab(tab)
  }

  const handleSearch = (e) => {
    setSearchTerm(e.target.value)
  }

  const handleCreateCoupon = async () => {
    const hasPermission = await checkPermission("Coupens", "create")
    if (!hasPermission) return
    setEditMode(false)
    setCouponToEdit(null)
    setShowCreateDrawer(true)
  }

  const handleEditCoupon = async (coupon) => {
    const hasPermission = await checkPermission("Coupens", "update")
    if (!hasPermission) return
    const fullCouponData = apiCoupons.find((c) => c.id === coupon.id)
    if (fullCouponData) {
      console.log("Full coupon data for editing:", fullCouponData)
      setEditMode(true)
      setCouponToEdit(fullCouponData)
      setShowCreateDrawer(true)
    } else {
      console.warn("Could not find full coupon data for editing. Using limited data.")
      setEditMode(true)
      setCouponToEdit(coupon._originalData || coupon)
      setShowCreateDrawer(true)
    }
  }

  const handleSaveCoupon = (couponData, editId = null) => {
    if (editMode && editId) {
      const couponData = apiCoupons.find((coupon) => coupon.id === editId)
      if (couponData) {
        const updatedCouponData = JSON.parse(JSON.stringify(couponData))

        updatedCouponData.coupon_code = couponData.coupon_code
        updatedCouponData.discount = couponData.discount

        updatedCouponData.coupon_id = couponData.id
        console.log("Sending coupon update payload:", updatedCouponData)

        UpdateCouponsData(updatedCouponData)
          .then((response) => {
            console.log("Coupon updated successfully:", response)
            showToast( "Coupon updated successfully!","success")
            setEditMode(false)
            setCouponToEdit(null)
            loadCoupons()
            setTimeout(() => {
              setShowCreateDrawer(false)
            }, 3000)
          })
          .catch((error) => {
            console.error("Error updating coupon:", error)
            showToast( "Failed to update coupon. Please try again.","error")
          })
      } else {
        showToast( "Failed to update coupon. Coupon data not found.","error")
      }
    } else {
      console.log("Coupon created:", couponData)
      showToast( "Coupon created successfully!","success")
      setEditMode(false)
      setCouponToEdit(null)
      loadCoupons()
      setTimeout(() => {
        setShowCreateDrawer(false)
      }, 3000)
    }
  }

  const handleDeleteConfirmed = async () => {
    if (!couponToDelete) return
    const coupon = couponToDelete
    setCouponToDelete(null)
    setShowDeleteConfirmation(false)
    try {
      const formData = {
        coupon_id: coupon.id,
        event_id: coupon._originalData.event_id,
        coupon_code: coupon._originalData.coupon_code,
        discount: coupon._originalData.discount,
        discount_type: coupon._originalData.discount_type,
        expiry_date: coupon._originalData.expiry_date?.split("T")[0],
        usage_limit_enabled: coupon._originalData.usage_limit_enabled,
        total_usage_limit: coupon._originalData.total_usage_limit,
        usage_limit_per_buyer: coupon._originalData.usage_limit_per_buyer,
        coupon_status: "deleted",
        apply_to_all_tickets: coupon._originalData.apply_to_all_tickets,
        apply_discount_on: coupon._originalData.apply_discount_on || "tickets",
      }
      console.log("Sending delete payload:", formData)
      const response = await UpdateCouponsData(formData)
      if (response) {
        showToast( "Coupon deleted successfully!","success")
        loadCoupons()
      }
    } catch (error) {
      console.error("Error deleting coupon:", error)
      showToast( "Failed to delete coupon. Please try again.","error")
    }
  }

  const handleCopyCouponCode = (code, event) => {
    event.stopPropagation()
    navigator.clipboard
      .writeText(code)
      .then(() => {
        showToast(`Copied: ${code}`)
      })
      .catch((err) => {
        console.error("Failed to copy: ", err)
        showToast(`Failed to copy: ${err}`,"error")
      })
  }

  // Status Toggle Component
  const StatusToggle = ({ status, couponId }) => {
    const [currentStatus, setCurrentStatus] = useState(status)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)
    const isActive = currentStatus === "active"
    const isExpiredOrDeleted = status === "expired" || status === "deleted"

    const handleStatusToggle = async () => {
      const hasPermission = await checkPermission("Coupens", "update")
      if (!hasPermission) return
      setIsLoading(true)
      setError(null)
      try {
        const couponData = apiCoupons.find((coupon) => coupon.id === couponId)
        if (!couponData) {
          setError("Could not find coupon data")
          setIsLoading(false)
          return
        }
        const newStatus = isActive ? "paused" : "active"
        const formData = {
          coupon_id: couponId,
          event_id: couponData.event_id,
          coupon_code: couponData.coupon_code,
          discount: couponData.discount,
          discount_type: couponData.discount_type,
          expiry_date: couponData.expiry_date?.split("T")[0],
          usage_limit_enabled: couponData.usage_limit_enabled,
          total_usage_limit: couponData.total_usage_limit,
          usage_limit_per_buyer: couponData.usage_limit_per_buyer,
          coupon_status: newStatus,
          apply_to_all_tickets: couponData.apply_to_all_tickets,
        }
        console.log("Sending status update payload:", formData)
        const response = await UpdateCouponsData(formData)
        if (response) {
          setCurrentStatus(newStatus)
          const updatedCoupons = coupons.map((coupon) =>
            coupon.id === couponId ? { ...coupon, status: newStatus } : coupon,
          )
          setCoupons(updatedCoupons)
          showToast( `Coupon ${newStatus === "active" ? "activated" : "paused"} successfully!`,"success",)
        }
      } catch (error) {
        console.error("Error updating coupon status:", error)
        setError("Failed to update status. Please try again.")
        showToast( "Failed to update coupon status.","error")
      } finally {
        setIsLoading(false)
      }
    }

    return (
      <div className="d-flex align-items-center justify-content-center">
        <div className="status-toggle-container">
          <label className="switch">
            <input
              type="checkbox"
              className="lv-btn small-switch"
              checked={isActive}
              onChange={handleStatusToggle}
              disabled={isLoading || isExpiredOrDeleted}
            />
            <span className="slider round"></span>
          </label>
          {isLoading && (
            <div className="ms-2">
              <SmallSpinner size={14} />
            </div>
          )}
        </div>
        {error && <div className="text-danger small mt-1">{error}</div>}
      </div>
    )
  }

  // Coupon Actions Component
  const CouponActions = ({ coupon }) => {
    const [showMenu, setShowMenu] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)
    const [error, setError] = useState(null)
    const menuRef = useRef(null)
    const isExpiredOrDeleted = coupon.status === "expired" || coupon.status === "deleted"

    useEffect(() => {
      function handleClickOutside(event) {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
          setShowMenu(false)
        }
      }
      document.addEventListener("mousedown", handleClickOutside)
      return () => {
        document.removeEventListener("mousedown", handleClickOutside)
      }
    }, [])

    const handleDeleteClick = async () => {
      const hasPermission = await checkPermission("Coupens", "delete")
      if (!hasPermission) return
      setCouponToDelete(coupon)
      setShowDeleteConfirmation(true)
      setShowMenu(false)
    }

    if (isExpiredOrDeleted) {
      return (
        <div className="position-relative" ref={menuRef}>
          <span className="text-muted">—</span>
        </div>
      )
    }

    return (
      <div className="position-relative" ref={menuRef}>
        <div
          variant="link"
          className="p-0 text-center cupuons_dot_div"
          onClick={() => setShowMenu(!showMenu)}
          disabled={isDeleting}
        >
          {isDeleting ? <SmallSpinner size={16} /> : <FiMoreVertical />}
        </div>
        {error && <div className="text-danger small mt-1">{error}</div>}
        {showMenu && (
          <div className="coupon-actions-menu">
            <div
              className="coupon-action-item"
              onClick={() => {
                handleEditCoupon(coupon)
                setShowMenu(false)
              }}
            >
              <i className="fa fa-edit me-2"></i> Edit
            </div>
            <div className="coupon-action-item text-danger" onClick={handleDeleteClick}>
              <i className="fa fa-trash me-2"></i> Delete
            </div>
          </div>
        )}
      </div>
    )
  }

  const tableData = useMemo(
    () => ({
      columns: [
        {
          label: <div className="fw-bold">Coupon Code</div>,
          field: "coupon_code",
          sort: "asc",
        },
        {
          label: <div className="fw-bold">Discount</div>,
          field: "discount",
          sort: "asc",
        },
        {
          label: <div className="fw-bold">Expiry</div>,
          field: "expiry",
          sort: "asc",
        },
        {
          label: <div className="fw-bold">Status</div>,
          field: "status",
          sort: "asc",
        },
        {
          label: "Actions",
          field: "actions",
        },
      ],
      rows: coupons
        .filter((coupon) => {
          if (activeTab === "all") return true
          return coupon.status === activeTab
        })
        .filter((coupon) => {
          if (!searchTerm) return true
          return coupon.coupon_code.toLowerCase().includes(searchTerm.toLowerCase())
        })
        .map((coupon) => ({
          coupon_code: (
            <div className="coupon-code">
              {coupon.coupon_code}
              <FiCopy className="copy-icon" onClick={(e) => handleCopyCouponCode(coupon.coupon_code, e)} />
            </div>
          ),
          discount: coupon.discount,
          usage: coupon.usage,
          applyTo: coupon.applyTo,
          expiry: coupon.expiry,
          status: <StatusToggle status={coupon.status} couponId={coupon.id} />,
          actions: <CouponActions coupon={coupon} />,
        })),
    }),
    [coupons, activeTab, searchTerm],
  )

  const LoadingSpinner = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "3rem",
      }}
    >
      <div
        style={{
          width: "40px",
          height: "40px",
          border: "4px solid #e5e7eb",
          borderTop: "4px solid #184778",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      ></div>
      <p
        style={{
          marginTop: "1rem",
          color: "#6b7280",
          fontSize: "0.875rem",
        }}
      >
        Loading coupons...
      </p>
    </div>
  )

  // Check Admin User Permission
  const [checkUserLoading, setCheckUserLoading] = useState(false)
  const fetchPermission = async () => {
    setCheckUserLoading(true)
    try {
      const hasPermission = await checkPermission("Coupens", "view")
      if (!hasPermission) return
    } catch (error) {
      console.error("Error Check Permission:", error)
    } finally {
      setCheckUserLoading(false)
    }
  }

  useEffect(() => {
    fetchPermission()
  }, [])

  return (
    <>
      {" "}
      {checkUserLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "500px" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <div
          style={{
            minHeight: "100vh",
            backgroundColor: "#f8fafc",
            padding: "24px 15px",
          }}
        >
          <ToastMessage />

          {notification.show && (
            <div
              className={`notification-popup ${notification.type}`}
              style={{
                position: "fixed",
                top: "20px",
                right: "20px",
                zIndex: 9999,
                minWidth: "300px",
                padding: "15px",
                borderRadius: "5px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                backgroundColor:
                  notification.type === "success"
                    ? "#d4edda"
                    : notification.type === "error"
                      ? "#f8d7da"
                      : notification.type === "info"
                        ? "#d1ecf1"
                        : "#fff",
                border: `1px solid ${notification.type === "success"
                  ? "#c3e6cb"
                  : notification.type === "error"
                    ? "#f5c6cb"
                    : notification.type === "info"
                      ? "#bee5eb"
                      : "#ddd"
                  }`,
                color:
                  notification.type === "success"
                    ? "#155724"
                    : notification.type === "error"
                      ? "#721c24"
                      : notification.type === "info"
                        ? "#0c5460"
                        : "#333",
                transition: "all 0.3s ease",
              }}
            >
              <div
                className="notification-content"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {notification.type === "success" ? (
                    <i
                      className="fa fa-check-circle notification-icon"
                      style={{ marginRight: "10px", fontSize: "20px" }}
                    ></i>
                  ) : notification.type === "error" ? (
                    <i
                      className="fa fa-exclamation-circle notification-icon"
                      style={{ marginRight: "10px", fontSize: "20px" }}
                    ></i>
                  ) : (
                    <i
                      className="fa fa-info-circle notification-icon"
                      style={{ marginRight: "10px", fontSize: "20px" }}
                    ></i>
                  )}
                  <span className="notification-message">{notification.message}</span>
                </div>
                <button
                  className="notification-close"
                  onClick={closeNotification}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "20px",
                    cursor: "pointer",
                    color: "inherit",
                    marginLeft: "10px",
                  }}
                >
                  ×
                </button>
              </div>
            </div>
          )}

          {renderHeader()}
          {renderStatsCards()}
          {renderFiltersAndTabs()}
          {renderDataTable()}

          <CreateCouponDrawer
            show={showCreateDrawer}
            onHide={() => {
              setShowCreateDrawer(false)
              setEditMode(false)
              setCouponToEdit(null)
            }}
            onSave={handleSaveCoupon}
            editMode={editMode}
            couponToEdit={couponToEdit}
          />

          <ConfirmationModal
            show={showDeleteConfirmation}
            title="Delete Coupon"
            message={`Are you sure you want to delete the coupon "${couponToDelete?.coupon_code}"? This action cannot be undone.`}
            confirmButtonText="Delete"
            confirmButtonVariant="danger"
            onConfirm={handleDeleteConfirmed}
            onCancel={() => {
              setShowDeleteConfirmation(false)
              setCouponToDelete(null)
            }}
          />
        </div>
      )}
    </>
  )
}

// Add keyframes for spinner animation
const spinKeyframes = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`

if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style")
  styleSheet.type = "text/css"
  styleSheet.innerText = spinKeyframes
  document.head.appendChild(styleSheet)
}

export default Coupons